import { render, staticRenderFns } from "./image-text-left.vue?vue&type=template&id=06ffcb59&scoped=true"
import script from "./image-text-left.vue?vue&type=script&lang=js"
export * from "./image-text-left.vue?vue&type=script&lang=js"
import style0 from "./image-text-left.vue?vue&type=style&index=0&id=06ffcb59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ffcb59",
  null
  
)

export default component.exports